import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { cets_item } from "../../../json/cets";
import "../stylessh.css";

const Cets = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const renderText = () => {
    const { cets_item_text, cets_item_list } = cets_item[0];

    return (
      <div>
        <p className="text-justify">{cets_item_text}</p>
        <ul className="list-mark">
          {cets_item_list.map((item, index) => (
            <li key={index}>{typeof item === "object" ? <a href={item.url}>{item.label}</a> : item}</li>
          ))}
        </ul>
      </div>
    );
  };

  return (
    <div className="container transparencia-container">
      <div className="row">
        <div className="col-12">
          <div className="transparencia_title">
            <h1>Centro Estatal de la Transfusión Sanguínea</h1>
            <hr className="tramitehr" />
          </div>
        </div>
      </div>
      <div className="row">
        {renderText()}
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3747.3488884991293!2d-98.77866788716314!3d20.077697422023743!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85d1a0ef90fff9a1%3A0xec0c67b83c96b6ad!2sCentro+estatal+de+transfusi%C3%B3n+sanguinea!5e0!3m2!1ses!2smx!4v1556041972204!5m2!1ses!2smx"
          width="100%"
          height="300"
          frameBorder="0"
          style={{ border: 0, marginBottom: 50 }}
          allowFullScreen
        ></iframe>
      </div>
    </div>
  );
};

export default Cets;
